<template>
  <div class="lv-bread-crumb">
    <div
      v-for="(item, itemIndex) in list"
      :key="itemIndex"
      class="lv-bread-crumb__items mr-8"
    >
      <i
        v-if="itemIndex !== 0"
        class="icon-chevron-forward lv-bread-crumb__icon mr-8"
      />
      <WsTextButton001
        narrow
        noPadding
        :primary="item.to ? true : false"
        :isDisable="item.to ? false : true"
        @click="$_onClick(item)"
      >{{ $t(item.text) }}</WsTextButton001>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
    },
  },
  methods: {
    $_onClick(item) {
      if (item.hasCustomAction) this.$emit('click', item);
      else this.$router.push(item.to);
    }
  }
}
</script>